import {call, put, takeLatest} from 'redux-saga/effects';
import TotalLifetimePlaysApi from '../../api/TotalLifetimePlaysApi';
import lifetimePlaysActions from '../../actions/fortnite-game/lifetimePlays.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getLifetimePlays(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(TotalLifetimePlaysApi.getData, action.payload);
        yield put(
            lifetimePlaysActions.getLifetimePlaysSuccess({
                data,
                error: data.list && data.list.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(lifetimePlaysActions.getLifetimePlaysFailed(getErrorCodeFromResponse(e), e));
    }
}

function* lifetimePlaysSaga() {
    yield takeLatest(lifetimePlaysActions.TYPES.GET_LIFETIME_PLAYS, getLifetimePlays);
}

export default lifetimePlaysSaga;
